import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSDialog } from '../dialog/index.esm.js';
import styles from '../../styles/uitk-egds-dialog.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSFullscreenDialogTheme;
(function (EGDSFullscreenDialogTheme) {
  EGDSFullscreenDialogTheme["CANVAS"] = "uitk-dialog-fullscreen-bg-canvas";
  EGDSFullscreenDialogTheme["DARK"] = "uitk-dialog-fullscreen-bg-dark";
  EGDSFullscreenDialogTheme["DEFAULT"] = "uitk-dialog-fullscreen-bg-default";
})(EGDSFullscreenDialogTheme || (EGDSFullscreenDialogTheme = {}));
class EGDSFullscreenDialog extends React.Component {
  static displayName = 'EGDSFullscreenDialog';
  static defaultProps = {
    theme: EGDSFullscreenDialogTheme.DEFAULT,
    wideContent: false
  };
  render() {
    const {
      className,
      wideContent,
      theme
    } = this.props;
    const wrapperClassNames = getClassNameList('uitk-dialog-fullscreen', theme, className, {
      'uitk-dialog-wide-content': wideContent
    });
    return jsx(EGDSDialog, {
      ...this.props,
      className: wrapperClassNames
    });
  }
}
export { EGDSFullscreenDialog, EGDSFullscreenDialogTheme };